import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const RepeatLeadIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className || "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_10293_119858)">
        <path
          fill="currentColor"
          d="M9 1C4.58187 1 1 4.58187 1 9C1 13.4181 4.58187 17 9 17C13.4181 17 17 13.4181 17 9C17 4.58187 13.4181 1 9 1ZM5.14656 8.99438C4.81875 8.985 4.61531 8.74438 4.62875 8.37844C4.6775 7.01219 5.67188 5.92125 7.02656 5.75344C7.18288 5.73365 7.34025 5.72322 7.49781 5.72219C8.35437 5.71906 9.21094 5.72062 10.0994 5.72062C10.0994 5.53687 10.0994 5.37438 10.0994 5.21156C10.0994 4.96156 10.2031 4.78 10.4362 4.67812C10.6694 4.57625 10.8766 4.62906 11.0528 4.80312C11.4031 5.14906 11.7525 5.49625 12.0966 5.84812C12.3425 6.09969 12.3434 6.42625 12.0981 6.67719C11.7544 7.02938 11.4044 7.37594 11.0547 7.72219C10.88 7.895 10.6728 7.96062 10.4388 7.86219C10.2047 7.76375 10.1025 7.57562 10.1 7.32781C10.0981 7.16406 10.1 7.00031 10.1 6.815C10.0275 6.81187 9.96344 6.80656 9.89937 6.80656C9.06104 6.80656 8.2225 6.80656 7.38375 6.80656C6.44875 6.80656 5.74625 7.48875 5.71125 8.42375C5.69719 8.78687 5.48281 9.00438 5.14656 8.99438ZM10.9841 12.2444C10.8095 12.2646 10.6339 12.2751 10.4581 12.2756C9.61438 12.2791 8.77063 12.2772 7.89937 12.2772C7.89937 12.4725 7.90188 12.6416 7.89937 12.8109C7.89469 13.0444 7.79125 13.2172 7.57406 13.3147C7.34875 13.4178 7.14219 13.3831 6.96969 13.215C6.59937 12.8547 6.23219 12.4909 5.87594 12.1181C5.66062 11.8934 5.66469 11.5691 5.88219 11.3434C6.23656 10.9759 6.60094 10.6163 6.96438 10.2594C7.13469 10.0928 7.34312 10.0406 7.56781 10.1378C7.7925 10.235 7.89594 10.4191 7.90063 10.6584C7.90406 10.8275 7.90063 10.9969 7.90063 11.1922H10.5881C11.5625 11.1922 12.2513 10.5269 12.2913 9.55C12.3053 9.21281 12.5216 8.99812 12.8434 9.0025C13.1653 9.00688 13.3772 9.23688 13.3747 9.57063C13.3612 10.9344 12.3322 12.0878 10.9841 12.2453V12.2444Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_10293_119858">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RepeatLeadIcon;
